import { render, staticRenderFns } from "./OkrSaveCard.vue?vue&type=template&id=0b60d9c0&scoped=true"
import script from "./OkrSaveCard.vue?vue&type=script&lang=js"
export * from "./OkrSaveCard.vue?vue&type=script&lang=js"
import style0 from "./OkrSaveCard.vue?vue&type=style&index=0&id=0b60d9c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b60d9c0",
  null
  
)

export default component.exports